/**
 * Remembers the last destination number typed into "Place a call", per
 * browser only — never committed, never sent anywhere else. A real phone
 * number is exactly the kind of sensitive call variable CLAUDE.md's own
 * rule keeps out of git (no production phone lists in source), so this is
 * deliberately local-storage-only, not a component default or a fixture.
 *
 * Same storage-like-interface shape as draftStorage.ts, for the same
 * reason: testable in this project's plain Node test environment with a
 * trivial in-memory fake.
 */
export interface LastDestinationStorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

const STORAGE_KEY = "uvi.adhoc-call.last-destination.v1";

export function loadLastDestination(storage: LastDestinationStorageLike): string {
  try {
    return storage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

/**
 * Storage can be full, disabled (private browsing) or unavailable —
 * remembering a destination failing is a convenience lost, never something
 * placing a call itself should fail over.
 */
export function saveLastDestination(storage: LastDestinationStorageLike, destination: string): void {
  try {
    storage.setItem(STORAGE_KEY, destination);
  } catch {
    // See above.
  }
}
